export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`logo ${compact ? "logo--compact" : ""}`}>
      <span className="logo__mark">F<span>·</span></span>
      {!compact && (
        <span>
          <strong>flussik</strong>
          <small>lecture française</small>
        </span>
      )}
    </div>
  );
}
